import { StyledAlert } from './style';

type variants = 'danger' | 'success';

export interface IAlertProps {
  text: string;
  width?: string;
  maxWidth?: string;
  variant?: variants;
}

const mapVariantToComponent: Record<variants, React.FC> = {
  ['danger']: () => (
    <span className="material-symbols-outlined error">error</span>
  ),
  ['success']: () => (
    <span className="material-symbols-outlined success">check_circle</span>
  ),
};

const mapVariantToProps: Record<variants, object> = {
  ['danger']: {
    background: '#ffffff',
    color: '#000000',
    borderColor: '#E4E4E7',
  },
  ['success']: {
    background: '#ffffff',
    color: '#000000',
    borderColor: '#E4E4E7',
  },
};

export const Alert: React.FC<IAlertProps> = ({
  text,
  width = '100%',
  maxWidth = '400px',
  variant = 'success',
}) => {
  const VariantIcon: React.FC = mapVariantToComponent[variant];

  return (
    <StyledAlert
      width={width}
      maxWidth={maxWidth}
      {...mapVariantToProps[variant]}
      gap={'13px'}
    >
      <VariantIcon />
      <div className="text">{text}</div>
    </StyledAlert>
  );
};
